import { useId } from "react"

import { SaveButton } from "@/components/shared/action-buttons"
import { LearnerPageChrome } from "@/pages/learners/page-chrome"
import { StudentProfileForm } from "@/pages/learners/students/edit.page"
import { useFormProps } from "@/pages/learners/students/page-props"
import { learnersSchoolStudent } from "@/routes"
import { usePathParams } from "@/lib/page-rendering"

// A school admin's student's profile form, in the school workspace: the
// student's own form under the student's record crumb.
export default function Page() {
  const id = useId()
  const { schoolId, id: studentId } = usePathParams()
  const {
    student: { user_attributes },
  } = useFormProps()

  const name = `${user_attributes.first_name} ${user_attributes.last_name}`

  return (
    <>
      <LearnerPageChrome
        identity={{ name }}
        action={<SaveButton form={id} />}
        records={{ "learners/school_students/show": name }}
      />
      <StudentProfileForm
        formId={id}
        action={learnersSchoolStudent({ schoolId, id: studentId }).url}
      />
    </>
  )
}
